var _style, _polygon, _polygon2, _polygon3, _polygon4, _line, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _line2, _line3, _line4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppIconEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:none;stroke:#DCDCDC;stroke-width:0.7384;}\n\t.st5{fill:url(#SVGID_5_);}\n\t.st6{fill:url(#SVGID_6_);}\n\t.st7{fill:url(#SVGID_7_);}\n\t.st8{fill:url(#SVGID_8_);}\n\t.st9{fill:url(#SVGID_9_);}\n\t.st10{fill:url(#SVGID_10_);}\n\t.st11{fill:url(#SVGID_11_);}\n\t.st12{fill:url(#SVGID_12_);}\n\t.st13{fill:url(#SVGID_13_);}\n\t.st14{fill:none;stroke:#FFFFFF;stroke-width:0.443;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.3581,
    y1: 7.8282,
    x2: 61.655,
    y2: 32.8264,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#525252",
      stopOpacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "40,78.3 11.1,61.7 40,45 68.9,61.7 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.1764,
    y1: 65.756,
    x2: 50.8152,
    y2: 78.2498,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A4A4A4"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "25.6,10 40,1.7 54.4,10 40,18.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 40,
    y1: 51.1677,
    x2: 54.4245,
    y2: 51.1677,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6F6F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8C8C8C"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "40,18.3 40,51.7 54.4,43.3 54.4,10  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.5671,
    y1: 51.1719,
    x2: 40,
    y2: 51.1719,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4A4A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8C8C8C"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "40,18.3 25.6,10 25.6,43.3 40,51.7  "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 25.6,
    y1: 10,
    x2: 40,
    y2: 18.3
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.8351,
    y1: 57.4239,
    x2: 58.0515,
    y2: 69.9232,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3F3F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCDCDC"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "40,18.3 54.4,10 68.9,18.3 54.4,26.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.4455,
    y1: 42.8296,
    x2: 68.87,
    y2: 42.8296,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4A4A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEBEBE"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "54.4,26.7 54.4,60 68.9,51.7 68.9,18.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.0126,
    y1: 42.8317,
    x2: 54.4455,
    y2: 42.8317,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEBEBE"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "54.4,26.7 40,18.3 40,51.7 54.4,60  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.952,
    y1: 57.4226,
    x2: 29.1713,
    y2: 69.9237,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3F3F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCDCDC"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "11.1,18.3 25.6,10 40,18.3 25.6,26.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.5671,
    y1: 42.8296,
    x2: 39.9874,
    y2: 42.8296,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4A4A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEBEBE"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "25.6,26.7 25.6,60 40,51.7 40,18.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.13,
    y1: 42.8339,
    x2: 25.5671,
    y2: 42.8339,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEBEBE"
    }
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "25.6,26.7 11.1,18.3 11.1,51.7 25.6,60  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.1887,
    y1: 32.419,
    x2: 50.8325,
    y2: 44.9157,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A4A4A4"
    }
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "25.6,43.3 40,35 54.4,43.3 40,51.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.0168,
    y1: 26.164,
    x2: 54.4413,
    y2: 26.164,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6F6F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8C8C8C"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "40,51.7 40,68.3 54.4,60 54.4,43.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.5797,
    y1: 26.1661,
    x2: 40.0168,
    y2: 26.1661,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4A4A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8C8C8C"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "40,51.7 25.6,43.3 25.6,60 40,68.3  "
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 11.1,
    y1: 18.3,
    x2: 25.6,
    y2: 26.7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 40,
    y1: 18.3,
    x2: 54.4,
    y2: 26.7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 25.6,
    y1: 43.3,
    x2: 40,
    y2: 51.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconEmpty);
export default __webpack_public_path__ + "static/media/app_icon_empty.ef0f5581c1da798d84445c9465da9891.svg";
export { ForwardRef as ReactComponent };